import { Column, Flex, Row } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import range from "lodash/range";
import React from "react";
import styled from "styled-components";

import { GhostBlock } from "@faire/retailer/components/GhostLoading/GhostBlock";
import { EAEAEA_PIXEL } from "@faire/retailer/consts/EAEAEA_PIXEL";

export const FilmstripBrandListSkeleton: React.FC = () => {
  return (
    <div data-test-id="filmstrip-brand-list-skeleton">
      {range(0, 4).map((index) => (
        <FilmstripBrandSkeleton key={index} row={index} />
      ))}
    </div>
  );
};

const FilmstripBrandSkeleton: React.FC<{ row: number }> = ({ row }) => {
  return (
    <Wrapper direction={{ mobileAndAbove: "column", tabletAndAbove: "row" }}>
      <Row align="center">
        <img
          src={EAEAEA_PIXEL}
          width="88px"
          height="88px"
          style={{ borderRadius: "50%" }}
        />
        <Spacer height="1x" />
        <Column>
          <GhostBlock $width="64px" $height="20px" />
          <Spacer height="1x" />
          <GhostBlock $width="192px" $height="20px" />
          <Spacer height="1x" />
          <GhostBlock $width="208px" $height="20px" />
        </Column>
      </Row>
      <Spacer height="2x" />
      <Row align="center" gap="1x">
        {range(0, 3).map((index) => (
          <img
            src={EAEAEA_PIXEL}
            width="142px"
            height="142px"
            key={`${row} ${index}`}
          />
        ))}
      </Row>
    </Wrapper>
  );
};

const Wrapper = styled(Flex)`
  cursor: progress;
  overflow: hidden;
  padding: ${getSpacing("3x", 0)};

  ${responsiveMediaQueries.tabletAndAbove} {
    padding: ${getSpacing("6x", 0)};
  }
`;
